import {
  Chip,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';
import { getArticleUnitLabel } from '../utils/inventoryArticlesUtils';

const InventoryArticlesDataTable = ({
  data,
  units = [],
  isLoading,
  actionsDisabled = false,
  onEdit,
  onDelete,
  onView,
}) => {
  return (
    <GeneralTableBox>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Código</HeadTableCell>
            <HeadTableCell>Nombre</HeadTableCell>
            <HeadTableCell>Descripción</HeadTableCell>
            <HeadTableCell>Unidad</HeadTableCell>
            <HeadTableCell>Código externo</HeadTableCell>
            <HeadTableCell>Estado</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : data && data.length > 0 ? (
            data.map((article) => (
              <TableRow key={article.uuid}>
                <RowTableCell>{article.code}</RowTableCell>
                <RowTableCell>{article.name}</RowTableCell>
                <RowTableCell>{article.description || '-'}</RowTableCell>
                <RowTableCell>{getArticleUnitLabel(article, units)}</RowTableCell>
                <RowTableCell>{article.external_code || '-'}</RowTableCell>
                <RowTableCell>
                  <Chip
                    label={article.is_active ? 'Activo' : 'Inactivo'}
                    color={article.is_active ? 'success' : 'default'}
                    size="small"
                  />
                </RowTableCell>
                <RowTableCell>
                  <Stack direction="row" spacing={0.5} justifyContent="center">
                    <Tooltip title="Ver detalle">
                      <IconButton
                        size="small"
                        onClick={() => onView?.(article)}
                        disabled={actionsDisabled}
                      >
                        <VisibilityIcon fontSize="small" color="primary" />
                      </IconButton>
                    </Tooltip>
                    <ActionIconButton
                      variant="edit"
                      onClick={() => onEdit(article)}
                      disabled={actionsDisabled}
                    />
                    <ActionIconButton
                      variant="delete"
                      onClick={() => onDelete(article)}
                      disabled={actionsDisabled}
                    />
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton message="No se encontraron artículos de inventario" colSpan={7} />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default InventoryArticlesDataTable;
